import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-c72574de"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "content__container"
};
const _hoisted_4 = {
  class: "table__container"
};
const _hoisted_5 = {
  class: "header"
};
const _hoisted_6 = {
  key: 0,
  class: "mg-r--10"
};
const _hoisted_7 = {
  class: "mg-r--10"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer",
    "height": "12px",
    "width": "12px"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_9 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 3
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "flex-j-center"
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "70%"
  }
};
const _hoisted_17 = {
  class: "mg-l--5"
};
import dayjs from 'dayjs';
import axios from 'axios';
import TagType from '@/views/common/TagType/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import { useBrandsByUser, useBroadCastList, useGenresList, useVodLanguages } from '@/utils/cacheData';
import { getOperatorNameListApi, getUserByCidApi } from '@/api/authority';
import { provide, nextTick, onMounted, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { elMessage, getTextWidth, isEmptyArray } from '@/utils';
import { formValidator, messageBox } from '@/utils/validate';
import { ElTree, ElMessageBox } from 'element-plus';
import { useCommon } from '@/store/useCommon';
import GetChannelDetail from './getChannelDetail/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { getItemByProp, fileDownload, debounce, downloadFile, downBase64File, removePropertyOfNull } from '@/utils/tools';
import { live_instance } from '@/api/instance';
import { getCurrentTime } from '@/utils/timeFormat';
import { AUDIT_COLOR_NEW, AUDIT_STATUS_NEW, PLAY_AUDIT_COLOR_NEW, PLAY_AUDIT_STATUS_NEW, paymentFormList } from '@/assets/config/dicts';
import { getReviewListApi, exportProgramInfoApi, getAgentCategoryApi, deleteVodInfoApi, translateSubtitlesApi, getProgramRelationCategoryApi, getCloudDiskOptionsApi } from '@/api/vodNew';
import BatchButton from '@/views/liveChannel/components/batchButton.vue';
import BatchLinkCloudDisk from '@/views/onDemandContent/Components/batchLinkCloudDisk.vue';
import PaidSetting from './paidSetting/index.vue';
const __default__ = {
  name: 'FilmReview'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const Edit = defineAsyncComponent(() => import('./edit.vue'));
    const Check = defineAsyncComponent(() => import('./Check/index.vue'));
    const CheckFilm = defineAsyncComponent(() => import('./CheckFilm/index.vue'));
    const CloudDiskInfo = defineAsyncComponent(() => import('./CloudDiskInfo/index.vue'));
    const BatchTable = defineAsyncComponent(() => import('./BatchTable/index.vue'));
    const AddDrama = defineAsyncComponent(() => import('./AddDrama/index.vue'));
    const AddMovie = defineAsyncComponent(() => import('./AddMovie/index.vue'));
    const RelevanceInfoDialog = defineAsyncComponent(() => import('@/components/RelevanceInfoDialog/index.vue'));
    const SubtitleTranslationTable = defineAsyncComponent(() => import('./components/SubtitleTranslationTable/index.vue'));
    const ManuallyUpload = defineAsyncComponent(() => import('@/components/Upload/ManuallyUpload.vue'));
    const DialogProgress = defineAsyncComponent(() => import('@/components/DialogProgress/index.vue'));
    const {
      t
    } = useI18n();
    const tableRef = ref();
    const uploadRef = ref();
    const uploadTreeRef = ref();
    const tableWarpRef = ref(null);
    const channelDetaiObj = ref({
      visible: false,
      data: null
    });
    const paidSettingObj = reactive({
      visible: false,
      programIds: [],
      programType: ''
    }); // 导入进度条

    const importPercentage = ref(0);
    let cancelAxios = ref(axios.CancelToken.source());
    const dialogProgressRef = ref(null);
    const cloudDiskOptions = ref([{
      id: '',
      username: t('全部')
    }]);
    const genresIdOptions = ref([{
      name: t('全部'),
      id: ''
    }]);
    const cloudDiskInfoObj = ref({
      visible: false,
      data: null,
      programInfo: {}
    }); // 是否为VNO账号

    const isVnoUser = computed(() => useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS'));
    const TYPE_OPTION = {
      movie: t('单片'),
      tv_series: t('剧集')
    };
    const CODING_STATUS = {
      H264: 'H.264',
      H265: 'H.265'
    };
    const check = reactive({
      visible: false
    });
    const checkFilm = reactive({
      visible: false,
      auditStatus: -1
    });
    const edit = reactive({
      visible: false,
      pageFrom: ''
    });
    const batchTable = reactive({
      visible: false
    });
    const addDrama = reactive({
      visible: false
    });
    const addMovie = reactive({
      visible: false
    });
    const dialogProgress = reactive({
      visible: false
    });
    const relevanceInfoDialog = reactive({
      visible: false
    });
    const subtitleTranslationTable = reactive({
      visible: false
    });
    const cloudDiskDialog = ref({
      visible: false,
      data: null,
      programType: 'movie',
      mode: 'bind'
    });
    const data = reactive({
      languageOptions: [],
      detailInfo: {
        id: '',
        programType: '',
        releaseStatus: ''
      }
    });
    const uploadConfig = reactive({
      formList: [{
        label: '类型',
        prop: 'type',
        widgetType: 'Select',
        list: [{
          label: t('单片'),
          value: 'movie'
        }, {
          label: t('剧集'),
          value: 'tv_series'
        }],
        change: val => {
          dialogConfig.config.title = val === 'movie' ? '导入影片' : '导入剧集';
        }
      }],
      formData: {
        file: [],
        selectTreeData: [],
        type: 'movie'
      },
      rules: {
        file: [{
          required: true,
          validator: (rules, value, callback) => {
            if (isEmptyArray(value)) {
              callback(new Error(t('请上传文件')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        type: [{
          required: true,
          trigger: 'blur'
        }]
      }
    });
    const dialogConfig = reactive({
      visible: false,
      action: 'movie',
      config: {
        title: '导入影片'
      },
      confirm: done => {
        formValidator(uploadRef.value).then(() => {
          dialogProgress.visible = true;
          cancelAxios.value = axios.CancelToken.source();
          setTimeout(() => {
            handleImportData(done);
          }, 100);
        }, () => done());
      }
    }); // 导入

    const handleImportData = async done => {
      let params = new FormData();
      params.append('file', uploadConfig.formData.file[0].raw);
      uploadConfig.formData.selectTreeData.length && params.append('categoryIdList', uploadConfig.formData.selectTreeData);
      params.append('cid', sessionStorage.getItem('currentCid'));
      params.append('cpspId', sessionStorage.getItem('currentCpspid'));
      params.append('programType', uploadConfig.formData.type);

      try {
        const res = await live_instance({
          method: 'post',
          url: 'vod-content/program/import',
          data: params,
          type: 'upload',
          duration: 5000,
          timeout: 1800000,
          cancelToken: cancelAxios.value.token,
          onUploadProgress: progress => {
            // 上传进度--格式化成百分数
            let progressVal = Math.floor(progress.loaded / progress.total * 100) > 0 ? Math.floor(progress.loaded / progress.total * 100) : importPercentage.value;
            importPercentage.value = progressVal === 100 ? 99 : progressVal;
          }
        });

        if (res.code == '0') {
          importPercentage.value = 100;
          done();
          setTimeout(() => {
            onPercentageSuccess();
            elMessage('success', '操作成功');
          }, 200);
        } else {
          dialogProgressRef.value.changeShowText(t('导入失败'));
          importPercentage.value = 100;

          if (res.code == 'B0002') {
            downloadFile(res.data);
          } else if (res.code == 'B0003') {
            downloadFile(res.data);
          } else if (res.code == 'B0004') {
            downBase64File(res.data, uploadConfig.formData.type === 'movie' ? `Movies_${dayjs(new Date()).format('YYYY_MM_DD')}` : `Series_${dayjs(new Date()).format('YYYY_MM_DD')}`);
          }

          done();
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          elMessage('warning', 'Upload has been canceled');
          importPercentage.value = 0;
        } else {
          elMessage('warning', 'Upload error, please upload again.');
          importPercentage.value = 0;
        }

        done();
      }
    }; // 搜索查询用额外用到的参数


    const searchData = reactive({
      auditStatus: '',
      categoryIds: [],
      //type: 1,
      sortType: 'desc',
      sortField: 'releaseTime',
      ifContain: false
    });
    const treeData = reactive({
      loading: false,
      dataList: [],
      props: {
        id: 'id',
        label: 'name',
        children: 'children',
        logo: 'logo'
      }
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择品牌',
        labelKey: 'prefixName',
        valueKey: 'cid',
        list: [],
        change: val => {
          searchData.categoryIds = [];
          sessionStorage.setItem('currentCid', val);
          searchConfig.formData.operatorId = '';
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getUserByCid({
            cid: val
          });
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_FR_BS') > -1;
        },
        disabled: useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS')
      }, {
        label: '关键字筛选',
        prop: 'keyword',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }, {
        label: '分类属性',
        prop: 'genresId',
        widgetType: 'Select',
        placeholder: '请选择分类属性',
        labelKey: 'name',
        valueKey: 'id',
        list: genresIdOptions,
        loading: false,
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        },
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'genresId');

          if (isVisible && genresIdOptions.value.length === 1) {
            nowItem.loading = true;
            await getGenres();
            nowItem.loading = false;
          }
        }
      }, {
        label: '语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择语言',
        valueKey: 'code',
        suffix: true,
        labelWidth: '6.25vw',
        change: val => {
          if (val == '') searchData.ifContain = false;
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        },
        list: []
      }, {
        label: '编码协议',
        prop: 'videoCode',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: 'H.264',
          value: 'H264'
        }, {
          label: 'H.265',
          value: 'H265'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '创建时间',
        prop: 'time',
        widgetType: 'date',
        placeholder: '请选择时间',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        change: debounce(val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }, 200)
      }, {
        label: '操作用户',
        prop: 'operatorId',
        widgetType: 'Select',
        filterable: true,
        placeholder: '',
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          name: t('全部'),
          id: ''
        }],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_OU') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '类型',
        prop: 'programType',
        widgetType: 'Select',
        placeholder: '请选择类型',
        list: [{
          label: t('单片'),
          value: 'movie'
        }, {
          label: t('剧集'),
          value: 'tv_series'
        }],
        change: val => {
          sessionStorage.setItem('currentProgramType', val);
          searchConfig.formData.genresId = '';
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getGenres();
          getReviewList();
        }
      }, {
        label: '剧集状态',
        prop: 'playAuditStatus',
        widgetType: 'Select',
        list: [{
          label: '全部',
          value: ''
        }, {
          label: '未审核',
          value: 'unaudited'
        }, {
          label: '已审核',
          value: 'audited'
        }, {
          label: '审核中',
          value: 'auditing'
        }, {
          label: '未通过',
          value: 'not_approved'
        }],
        translation: true,
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CS_S') > -1;
        }
      }, {
        label: '运营商',
        prop: 'cpspId',
        widgetType: 'treeSelect',
        filterable: true,
        list: [],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
        },
        change: val => {
          sessionStorage.setItem('currentCpspid', val);
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '上传字幕',
        prop: 'subtitleLanguage',
        widgetType: 'Select',
        filterable: true,
        valueKey: 'code',
        list: [],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '翻译字幕',
        prop: 'subtitleStatus',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: t('未翻译'),
          value: 'not_translated'
        }, {
          label: t('已完成'),
          value: 'translated'
        }, {
          label: t('翻译中'),
          value: 'translating'
        }],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_FR_TS') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '云盘账号',
        prop: 'cloudDiskAccountId',
        widgetType: 'Select',
        list: cloudDiskOptions,
        labelKey: 'username',
        valueKey: 'id',
        loading: false,
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        },
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'cloudDiskAccountId');

          if (isVisible && cloudDiskOptions.value.length <= 1) {
            nowItem.loading = true;
            await getCloudDiskOptions();
            nowItem.loading = false;
          }
        }
      }],
      formData: {
        // cid: Number(sessionStorage.getItem('currentCid')),
        cid: null,
        keyword: '',
        genresId: '',
        audioLanguage: '',
        programType: sessionStorage.getItem('currentProgramType') || 'movie',
        time: '',
        updateTime: '',
        videoCode: '',
        operatorId: '',
        cpspId: null,
        playAuditStatus: '',
        subtitleLanguage: '',
        subtitleStatus: '',
        cloudDiskAccountId: ''
      }
    });
    const batchBtnDisabled = ref(false);
    const showTranslate = ref(true);
    const tableConfig = reactive({
      viewLoading: false,
      data: [],
      isCardBlock: true,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      // scrollbarAlwaysOn: true,
      headerButtonsList: [{
        label: '获取节目详情',
        func: () => {
          channelDetaiObj.value.visible = true;
          channelDetaiObj.value.data = {
            programType: searchConfig.formData.programType,
            cid: searchConfig.formData.cid,
            cpspId: searchConfig.formData.cpspId
          };
        }
      }, {
        label: '批量操作',
        key: 1,
        disabled: batchBtnDisabled.value,
        func: () => {},
        cellSlot: true,
        list: [{
          label: '审核',
          func: () => {
            const stateArr = selectTableConfig.selectData.map(item => item.auditStatus);
            const hasSameValue = Array.from(new Set(stateArr)).length === 1;
            let crawledItemArr = selectTableConfig.selectData.filter(item => item.auditStatus == 'not_crawled' || item.audioStatus == 'crawled_error');

            if (selectTableConfig.selectData.length === 0) {
              return elMessage('warning', '请先勾选需要批量操作的影片');
            } else if (crawledItemArr.length > 0) {
              return elMessage('warning', '请勾选已爬取的影片');
            } else if (!hasSameValue) {
              return elMessage('warning', '请先勾选状态相同的影片');
            } else {
              batchTable.visible = true;
            }
          },
          controller: config => {
            config.disabled = !selectTableConfig.selectData.length ? true : false;
            return true;
          }
        }, {
          label: '提交翻译',
          func: async () => {
            if (selectTableConfig.selectData.length === 0) {
              return elMessage('warning', '请先勾选需要翻译的影片');
            }

            try {
              tableConfig.viewLoading = true;
              const ids = selectTableConfig.selectData.map(item => item.id);
              const res = await translateSubtitlesApi({
                ids,
                programType: searchConfig.formData.programType
              });

              if (res.code == '0') {
                elMessage('success', '操作成功');
                getReviewList();
                tableRef.value && tableRef.value.commonTableRef.clearSelection();
              }

              tableConfig.viewLoading = false;
            } catch (error) {
              tableConfig.viewLoading = false;
            }
          },
          controller: config => {
            config.disabled = !selectTableConfig.selectData.length ? true : false;
            return showTranslate.value;
          }
        }, {
          label: '关联云盘',
          //permissionKey: 'LC_CR_TS',
          func: () => {
            if (selectTableConfig.selectData.length === 0) {
              return elMessage('warning', '先勾选需要批量操作的影片');
            }

            cloudDiskDialog.value.visible = true;
            cloudDiskDialog.value.programType = searchConfig.formData.programType;
            cloudDiskDialog.value.mode = 'bind';
            cloudDiskDialog.value.data = selectTableConfig.selectData.map(item => item.id);
          }
        }, {
          label: '取消关联云盘',
          //permissionKey: 'LC_CR_TS',
          func: () => {
            if (selectTableConfig.selectData.length === 0) {
              return elMessage('warning', '先勾选需要批量操作的影片');
            }

            cloudDiskDialog.value.visible = true;
            cloudDiskDialog.value.programType = searchConfig.formData.programType;
            cloudDiskDialog.value.mode = 'unbind';
            cloudDiskDialog.value.data = selectTableConfig.selectData.map(item => item.id);
          }
        }, {
          label: '付费',
          func: () => {
            if (selectTableConfig.selectData.length === 0) return elMessage('error', '请至少选择一个频道');
            paidSettingObj.visible = true;
            paidSettingObj.programIds = selectTableConfig.selectData.map(item => item.id);
            paidSettingObj.programType = searchConfig.formData.programType;
          }
        }, {
          label: '删除',
          type: 'danger',
          func: () => {
            if (selectTableConfig.selectData.length === 0) {
              return elMessage('warning', '请先勾选需要删除的影片');
            } else {
              deleteVodInfo();
            }
          },
          controller: config => {
            config.disabled = !selectTableConfig.selectData.length ? true : false;
            return true;
          }
        }]
      }, {
        label: '导出',
        func: async () => {
          exportData();
        }
      }, {
        label: '导入',
        func: () => {
          getAgentCategoryInfo(searchConfig.formData.cid);
          dialogConfig.visible = true;
          uploadConfig.formData.file = [];
          uploadConfig.formData.selectTreeData = [];
          uploadConfig.formData.type = 'movie';
          uploadRef.value && uploadRef.value.clearValidate();
          uploadTreeRef.value && uploadTreeRef.value.setCheckedKeys([]);
        }
      }, {
        label: '新增',
        func: () => {
          edit.visible = true;
          edit.pageFrom = '';
          data.detailInfo = {
            id: '',
            programType: searchConfig.formData.programType
          };
        }
      }, {
        label: '',
        cellSlot: true,
        key: 0,
        func: () => {}
      }],
      // maxHeight: '350px',
      'row-key': row => {
        return row.id;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name',
        width: 260,
        sortable: 'custom'
      }, {
        label: '信息源ID',
        prop: 'sourceId',
        width: 130
      }, {
        label: '类型',
        prop: 'programType',
        width: 100,
        formatter: value => TYPE_OPTION[value]
      }, {
        label: '状态',
        prop: 'auditStatus',
        width: 150,
        cellSlot: true,
        sortable: 'custom'
      }, {
        label: '剧集状态',
        prop: 'playAuditStatus',
        width: 190,
        sortable: 'custom',
        formatter: val => {
          return `<span class="text-overflow" style="color: ${PLAY_AUDIT_COLOR_NEW[val]}">
                   ${PLAY_AUDIT_STATUS_NEW[val] || '--'}</span>`;
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CS_S') > -1;
        }
      }, {
        label: '语言',
        prop: 'audioLanguage',
        width: 156,
        sortable: 'custom'
      }, {
        label: '编码协议',
        prop: 'videoCode',
        width: 150,
        sortable: 'custom'
      }, {
        label: '季',
        prop: 'seasons',
        width: 150,
        controller: () => {
          return searchConfig.formData.programType === 'tv_series';
        }
      }, {
        label: '分类属性',
        prop: 'genres',
        width: 230,
        sortable: 'custom'
      }, {
        label: '上传字幕',
        prop: 'subtitleLanguages',
        width: 170,
        sortable: 'custom'
      }, {
        label: '付费设置',
        prop: 'paymentForm',
        width: 170,
        sortable: 'custom',
        formatter: val => {
          return paymentFormList.find(item => item.value == val)?.label || '--';
        }
      }, {
        label: '翻译字幕',
        prop: 'subtitleStatus',
        width: 190,
        sortable: 'custom',
        cellSlot: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_FR_TS') > -1;
        }
      }, {
        label: '关联信息',
        prop: 'info',
        width: 130,
        cellSlot: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_AT') > -1;
        }
      }, {
        label: '云盘',
        prop: 'cloudDisk',
        width: 150,
        cellSlot: true
      }, {
        label: '操作用户',
        prop: 'operatorName',
        width: 150,
        sortable: 'custom'
      }, {
        label: '更新时间',
        prop: 'updateTime',
        width: 190,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '创建时间',
        prop: 'createTime',
        width: 190,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '发布时间',
        prop: 'releaseTime',
        width: 190,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        width: 260,
        showOverflowTooltip: false,
        buttonsList: [{
          label: '编辑',
          func: row => {
            const {
              id,
              programType
            } = row;
            data.detailInfo = {
              id,
              programType
            };
            edit.visible = true;
            edit.pageFrom = '';
          } // controller: (row) => {
          //   return row.releaseStatus === 'online' ? false : true;
          // }

        }, {
          label: '审核',
          func: row => {
            const {
              id,
              programType
            } = row;
            data.detailInfo = {
              id,
              programType
            };
            check.visible = true;
          },
          controller: row => {
            return row.releaseStatus === 'online' || row.auditStatus == 'not_crawled' || row.audioStatus == 'crawled_error' ? false : true;
          }
        }, {
          label: '影片',
          func: row => {
            const {
              id,
              programType,
              auditStatus,
              releaseStatus
            } = row;
            data.detailInfo = {
              id,
              programType,
              releaseStatus
            };
            checkFilm.visible = true;
            checkFilm.auditStatus = auditStatus;
          }
        }, {
          label: '删除',
          func: row => {
            const {
              releaseStatus
            } = row;

            if (releaseStatus === 'online') {
              ElMessageBox.confirm(t('该影片已上线，需要先下线才能删除。'), t('Warning'), {
                confirmButtonText: t('确定'),
                cancelButtonText: t('取消'),
                type: 'warning'
              });
            } else {
              messageBox('确定删除这条数据吗?').then(async () => {
                const {
                  id,
                  programType
                } = row;
                let idLanguageList = [];
                [id].forEach(id => {
                  let findItem = tableConfig.data.find(f => f.id == id);
                  findItem && idLanguageList.push({
                    id: findItem.id,
                    language: findItem.language
                  });
                });

                try {
                  tableConfig.viewLoading = true;
                  const {
                    code
                  } = await deleteVodInfoApi({
                    programIds: [id],
                    programType
                  });

                  if (code == '0') {
                    elMessage('success', '删除成功');
                    getReviewList();
                  } else {
                    tableConfig.viewLoading = false;
                  }
                } catch (error) {
                  tableConfig.viewLoading = false;
                }
              });
            }
          },
          controller: row => {
            return row.releaseStatus === 'online' ? false : true;
          }
        }, {
          label: '列表',
          func: row => {
            const {
              id,
              programType
            } = row;
            data.detailInfo = {
              id,
              programType
            };
            row.programType === 'tv_series' ? addDrama.visible = true : addMovie.visible = true;
          }
        }]
      }]
    }); // 取消导入

    const onPercentageCancel = done => {
      if (cancelAxios.value) {
        cancelAxios.value.cancel();
        importPercentage.value = 0;
      }

      done();
    }; // 导入完成


    const onPercentageSuccess = () => {
      dialogConfig.visible = false;
      dialogProgress.visible = false;
      getReviewList();
    };

    const deleteVodInfo = () => {
      let msgArr = [];
      let isReturn = false;
      let ids = [];
      selectTableConfig.selectData.forEach(item => {
        if (item.releaseStatus === 'online') {
          isReturn = true;
          msgArr.push(item.name);
        }

        ids.push(item.id);
      });

      if (isReturn) {
        return ElMessageBox.confirm(t('影片名已上线:', {
          list: msgArr.join(',')
        }), t('Warning'), {
          confirmButtonText: t('确定'),
          cancelButtonText: t('取消'),
          type: 'warning'
        });
      } else {
        messageBox('确定删除所选数据吗?').then(async () => {
          let programType = selectTableConfig.selectData[0].programType;
          let idLanguageList = [];
          ids.forEach(id => {
            let findItem = tableConfig.data.find(f => f.id == id);
            findItem && idLanguageList.push({
              id: findItem.id,
              language: findItem.language
            });
          });

          try {
            tableConfig.viewLoading = true;
            const res = await deleteVodInfoApi({
              programIds: ids,
              programType
            });

            if (res.code == '0') {
              elMessage('success', '删除成功');
              tableRef.value.commonTableRef.clearSelection();
              getReviewList();
            } else {
              tableConfig.viewLoading = false;
            }
          } catch (error) {
            tableConfig.viewLoading = false;
          }
        });
      }
    };

    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 获取审核数据列表


    const getReviewList = async () => {
      try {
        !tableConfig.viewLoading ? tableConfig.viewLoading = true : '';
        let params = { ...searchData,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...searchConfig.formData
        };

        if (params.time && params.time.length) {
          params.startTime = params.time[0];
          params.endTime = params.time[1];
          delete params.time;
        } // 语言如果选了不包含


        if (params.ifContain) {
          params.excludeAudioLanguage = params.audioLanguage;
          delete params.audioLanguage;
          delete params.ifContain;
        }

        const res = await getReviewListApi(removePropertyOfNull(params));

        if (res.code == '0') {
          tableConfig.data = res.data.records ? res.data.records : [];
          tableConfig.paginationConfig.total = res.data.total;
        }

        selectTableConfig.selectData.length && selectTableConfig.selectData.forEach(row => {
          tableRef.value.commonTableRef.toggleRowSelection(row, true);
        });
      } catch (error) {} // oldGenresList.value = JSON.parse(JSON.stringify(genresList.value));


      tableConfig.viewLoading ? tableConfig.viewLoading = false : '';
    }; // 获取操作用户


    const getUserByCid = async params => {
      try {
        getReviewList();
        const res = await getUserByCidApi(params);

        if (res.code == '0') {
          let item = getItemByProp(searchConfig.formList, 'operatorId');
          item.list = [{
            name: t('全部'),
            id: ''
          }, ...res.data.sort(function (a, b) {
            return a.name.trim().localeCompare(b.name.trim());
          })];
        }
      } catch (error) {}
    }; // 格式化运营商列表数据


    const formateOperatorOptions = list => {
      let newList = [];
      list.forEach((item, index) => {
        newList.push({
          value: item.id,
          label: item.name,
          children: item.children != null && item.children.length > 0 ? formateOperatorOptions(item.children) : null
        });
      });
      return newList;
    }; // 获取运营商


    const getOperatorList = async () => {
      if (useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1) {
        try {
          const res = await getOperatorNameListApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'cpspId');
            item.list = formateOperatorOptions(res.data);
          }
        } catch (error) {}
      }

      let currentCpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') : useCommon().userData.cpspId || 0;
      searchConfig.formData.cpspId = currentCpspid ? Number(currentCpspid) : useCommon().userData.cpspId || 0;
      sessionStorage.setItem('currentCpspid', String(searchConfig.formData.cpspId));
    };

    const brandsList = shallowRef([]); // 获取品牌选项数据

    const getBrands = async () => {
      try {
        tableConfig.viewLoading = true;
        await getOperatorList();

        if (useCommon().userData.permissionKey.indexOf('DC_FR_BS') > -1) {
          const brands = await useBrandsByUser();
          let searchItem = getItemByProp(searchConfig.formList, 'cid');
          if (searchItem) searchItem.list = brands;
          brandsList.value = brands;
          let cid = sessionStorage.getItem('currentCid');

          if (!cid) {
            sessionStorage.setItem('currentCid', isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid);
            cid = searchConfig.formData.cid = isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid;
          } else {
            searchConfig.formData.cid = Number(cid);
          }

          useCommon().userData.permissionKey.indexOf('DC_OU') > -1 ? getUserByCid({
            cid: cid || brands[0].cid
          }) : getReviewList();
        } else {
          let cid = useCommon().userData.cid[0] || 0;
          searchConfig.formData.cid = cid;
          sessionStorage.setItem('currentCid', cid);
          useCommon().userData.permissionKey.indexOf('DC_OU') > -1 ? getUserByCid({
            cid: cid
          }) : getReviewList();
        }
      } catch (error) {
        tableConfig.viewLoading = false;
      }
    }; // getBrands()


    provide('brandsList', brandsList);

    const initData = async () => {
      await Promise.all([getBrands(), getBroadCastList(), getAllLanguages()]);
    };

    onMounted(() => {
      getCloudDiskOptions();
      initData();
    }); // 获取主子品牌分类列表

    const getAgentCategoryInfo = async cid => {
      treeData.loading = true;
      let params = {
        cid,
        type: 2,
        isFilterRelationAgent: true
      };

      try {
        const res = await getAgentCategoryApi(params);

        if (res.code == '0') {
          res.data.forEach(item => {
            item.isParent = true;

            if (!item.children) {
              item.disabled = true;
            }
          });
          treeData.dataList = res.data;
          treeData.loading = false;
        }
      } catch (error) {
        console.log(error);
      }

      treeData.loading = false;
    }; // const genresList = ref([]);
    // 分类属性数据缓存,避免下拉切换造成视图数据影响
    //const oldGenresList = ref([]);
    // 获取分类属性


    const getGenres = async () => {
      try {
        const res = await useGenresList(localStorage.getItem('language') || 'en', searchConfig.formData.programType || 'movie');
        genresIdOptions.value = [{
          name: t('全部'),
          id: ''
        }, ...res]; // genresList.value = res;
      } catch (error) {}
    }; // provide('genresList', oldGenresList);
    // 获取所有语言


    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      data.languageOptions = res;
      let languageItem = getItemByProp(searchConfig.formList, 'audioLanguage');
      let uploadSubtitleItem = getItemByProp(searchConfig.formList, 'subtitleLanguage');
      languageItem.list = [{
        label: t('全部'),
        value: '',
        labelValue: '',
        code: ''
      }, ...res];
      uploadSubtitleItem.list = [{
        label: t('全部'),
        value: '',
        labelValue: '',
        code: ''
      }, {
        label: t('无字幕'),
        value: -1,
        labelValue: -1,
        code: 'none'
      }, ...res];
    };

    provide('languageOptions', data.languageOptions);
    const broadCastList = shallowRef([]); // 获取分辨率

    const getBroadCastList = async () => {
      const res = await useBroadCastList();
      broadCastList.value = res;
    };

    provide('broadCastList', broadCastList);
    const Tags = ref([{
      type: '',
      name: '全部'
    }, {
      type: 'crawled',
      name: '爬取'
    }, {
      type: 'terminal_audit',
      name: '终端审核'
    }, {
      type: 'unaudited',
      name: '未审核'
    }, {
      type: 'return',
      name: '退回审核'
    }, {
      type: 'not_approved',
      name: '未通过'
    }, {
      type: 'audited',
      name: '已审核'
    }]); // 处理 tags 点击事件

    const handleTagClick = tag => {
      if (searchData.auditStatus == tag.type) return;
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      tableConfig.paginationConfig.page = 1;
      searchData.auditStatus = tag.type;
      getReviewList();
    }; // 搜索查询


    const handleSearch = searchData => {
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      getReviewList();
    }; // 重置


    const handleReset = () => {
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      tableRef.value && tableRef.value.commonTableRef.clearSort();
      searchData.ifContain = false;
      searchData.categoryIds = [];
      searchData.sortType = 'desc';
      searchData.sortField = 'releaseTime';
      tableConfig.paginationConfig.page = 1;
      searchConfig.formData = {
        cid: Number(sessionStorage.getItem('currentCid')),
        keyword: '',
        genresId: '',
        audioLanguage: '',
        programType: sessionStorage.getItem('currentProgramType') || 'movie',
        time: '',
        updateTime: '',
        videoCode: '',
        operatorId: '',
        cpspId: Number(sessionStorage.getItem('currentCpspid')),
        subtitleLanguage: '',
        subtitleStatus: '',
        playAuditStatus: '',
        cloudDiskAccountId: ''
      };
      getGenres();
      getReviewList();
    };

    const handleImportCheck = (data, change) => {
      let nodes = uploadTreeRef.value.getCheckedNodes().concat(uploadTreeRef.value.getHalfCheckedNodes());
      let filterNodes = nodes.filter(node => {
        return node.children === null;
      });
      uploadConfig.formData.selectTreeData = filterNodes.map(item => item.id);
      uploadRef.value && uploadRef.value.validateField('selectTreeData');
    }; // 新增/编辑页面步骤一取消事件


    const handleCancel = () => {
      edit.visible = false;
    }; // 去编辑


    const goEdit = (dataInfo, {
      pageFrom
    }) => {
      data.detailInfo = dataInfo;
      edit.visible = true;
      edit.pageFrom = pageFrom;
    }; // 导出


    const exportData = debounce(async () => {
      if (tableConfig.data.length > 0) {
        try {
          tableConfig.viewLoading = true;
          let params = {
            cid: Number(sessionStorage.getItem('currentCid')),
            ...searchData,
            ...searchConfig.formData
          };

          if (selectTableConfig.selectData.length > 0) {
            const ids = selectTableConfig.selectData.map(item => item.id);
            params.idList = ids;
          }

          if (params.time && params.time.length) {
            params.startTime = params.time[0];
            params.endTime = params.time[1];
            delete params.time;
          }

          const res = await exportProgramInfoApi(removePropertyOfNull(params));
          fileDownload(res.data, res.processData.fileName, res.processData.contentType);
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
        } catch (error) {}

        tableConfig.viewLoading = false;
      }
    }, 500);

    const fileChange = file => {
      uploadConfig.formData.file = [file];
      uploadRef.value && uploadRef.value.validateField('file');
    };

    const handelRemove = file => {
      uploadConfig.formData.file = [];
      uploadRef.value && uploadRef.value.validateField('file');
    };

    const updateList = async () => {
      if (edit.pageFrom !== '') {
        switch (edit.pageFrom) {
          case 'Check':
            check.visible = true;
            edit.pageFrom = '';
            break;

          case 'CheckFilm':
            checkFilm.visible = true;
            edit.pageFrom = '';

          default:
            break;
        }
      } else {
        // 清空table复选框选中
        tableRef.value && tableRef.value.commonTableRef.clearSelection();
        getReviewList();
      }

      useCommon().clearIncludePage('FilmReview');
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width;
    }; // 表格排序


    const handleSortChange = debounce(async params => {
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        searchData.sortType = sortType;
        searchData.sortField = params.prop;
        getReviewList();
      } else {
        searchData.sortType = '';
        searchData.sortField = '';
        getReviewList();
      }
    }, 300);
    const infoTreeData = ref([]); // 关联信息item点击事件

    const relevanceInfoClick = async row => {
      infoTreeData.value = [];

      try {
        let params = {
          programId: row.id,
          programType: row.programType
        };
        const res = await getProgramRelationCategoryApi(params);

        if (res.code == '0') {
          infoTreeData.value = res.data;
        }
      } catch (error) {}

      relevanceInfoDialog.visible = true;
    };

    const rowData = ref(null);

    const subtitleTranslationClick = async row => {
      // TODO:调试隐藏
      // if (row.subtitleStatus != 'translated') return;
      rowData.value = row;
      subtitleTranslationTable.visible = true;
    }; // 打开关联云盘信息的弹框


    const showCloudDiskInfo = async (idList, row) => {
      // 根据id找到对应的名称
      let idNameList = [];
      cloudDiskOptions.value.forEach(item => {
        if (idList.includes(item.id)) {
          idNameList.push(item);
        }
      });
      cloudDiskInfoObj.value.visible = true;
      cloudDiskInfoObj.value.data = idNameList;
      cloudDiskInfoObj.value.programInfo = {
        programType: row.programType,
        programIdList: row.id
      };
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem ? findItem.width = width : '';
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    }; // 获取云盘选项


    const getCloudDiskOptions = async () => {
      try {
        const {
          code,
          data
        } = await getCloudDiskOptionsApi({
          name: useCommon().userData.name
        });

        if (code == 0) {
          cloudDiskOptions.value = data ? [{
            id: '',
            username: t('全部')
          }, {
            id: -1,
            username: t('未关联')
          }, ...data] : [{
            id: '',
            username: t('全部')
          }];
        }
      } catch (error) {}
    }; // 监听表单勾选，选中则批量按钮可以点击，否则不能点


    watch(() => selectTableConfig.selectData, (newVal, oldVal) => {
      if (newVal.length > 0) {
        batchBtnDisabled.value = false;
      } else {
        batchBtnDisabled.value = true;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_WidgetItem = _resolveComponent("WidgetItem");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_MPopper = _resolveComponent("MPopper");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, {
        suffix: _withCtx(scope => [scope.prop == 'audioLanguage' ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createVNode(_component_el_checkbox, {
          onChange: _cache[0] || (_cache[0] = () => getReviewList()),
          disabled: searchConfig.formData.audioLanguage == '',
          modelValue: searchData.ifContain,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchData.ifContain = $event),
          label: _unref(t)('不包含')
        }, null, 8, ["disabled", "modelValue", "label"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["size", "form-list", "form-data"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => Tags.value = $event),
        onOnTagClick: handleTagClick
      }, null, 8, ["modelValue"]), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [scope.key == 0 ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
          key: 0,
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])) : _createCommentVNode("", true), scope.key == 1 ? (_openBlock(), _createBlock(BatchButton, {
          key: 1,
          title: scope.label,
          "buttons-list": scope.list,
          disabled: batchBtnDisabled.value
        }, null, 8, ["title", "buttons-list", "disabled"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["buttons-list"])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", {
        class: "table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [_createVNode(_component_common_table, {
        pageSizesConfig: [10, 20, 40, 100, 200],
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getReviewList,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange),
        "column-list": columnConfig.columnList
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'playAuditStatus' ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_8]),
            content: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('剧集状态已审核提示')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('剧集状态未通过提示')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('剧集状态未审核提示')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('剧集状态审核中提示')), 1)]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          cellSlot: _withCtx(scope => [scope.column.property == 'auditStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", {
            class: "text-overflow",
            style: _normalizeStyle('color:' + _unref(AUDIT_COLOR_NEW)[scope.row.auditStatus])
          }, _toDisplayString(_unref(AUDIT_STATUS_NEW)[scope.row.auditStatus]), 5)])) : _createCommentVNode("", true), scope.column.property == 'info' ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "link",
            onClick: $event => relevanceInfoClick(scope.row)
          }, _toDisplayString(_ctx.$t('信息')), 9, _hoisted_10)) : _createCommentVNode("", true), scope.column.property == 'subtitleStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(scope.row.subtitleStatus == 'translated' ? 'link' : ''),
            onClick: $event => subtitleTranslationClick(scope.row)
          }, _toDisplayString(scope.row.subtitleStatus == 'not_translated' ? _ctx.$t('未翻译') : scope.row.subtitleStatus == 'translated' ? _ctx.$t('已完成') : scope.row.subtitleStatus == 'translating' ? _ctx.$t('翻译中') : '--'), 11, _hoisted_11)) : _createCommentVNode("", true), scope.column.property == 'cloudDisk' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [!scope.row.cloudDiskAccountIdList.length ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('未关联')), 1)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "link",
            onClick: $event => showCloudDiskInfo(scope.row.cloudDiskAccountIdList, scope.row)
          }, _toDisplayString(_ctx.$t('已关联')), 9, _hoisted_14))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSortChange", "column-list"])], 512)])])])), [[_directive_loading, tableConfig.viewLoading], [_vShow, !check.visible && !checkFilm.visible && !edit.visible && !batchTable.visible && !addDrama.visible && !addMovie.visible]]), edit.visible ? (_openBlock(), _createBlock(_unref(Edit), {
        key: 0,
        onUpdateList: updateList,
        "detail-info": data.detailInfo,
        onOnCancel: handleCancel
      }, null, 8, ["detail-info"])) : _createCommentVNode("", true), _createVNode(_unref(Check), {
        modelValue: check.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => check.visible = $event),
        onUpdateList: updateList,
        "detail-info": data.detailInfo,
        onToEdit: goEdit
      }, null, 8, ["modelValue", "detail-info"]), checkFilm.visible ? (_openBlock(), _createBlock(_unref(CheckFilm), {
        key: 1,
        onOnBack: _cache[4] || (_cache[4] = $event => checkFilm.visible = false),
        onUpdateList: updateList,
        auditStatus: checkFilm.auditStatus,
        "detail-info": data.detailInfo,
        onToEdit: goEdit
      }, null, 8, ["auditStatus", "detail-info"])) : _createCommentVNode("", true), _createVNode(_unref(BatchTable), {
        modelValue: batchTable.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => batchTable.visible = $event),
        onUpdateList: updateList,
        "select-list": selectTableConfig.selectData,
        "page-limit": tableConfig.paginationConfig.limit
      }, null, 8, ["modelValue", "select-list", "page-limit"]), _createVNode(_unref(AddDrama), {
        modelValue: addDrama.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => addDrama.visible = $event),
        onUpdateList: updateList,
        "detail-info": data.detailInfo
      }, null, 8, ["modelValue", "detail-info"]), addMovie.visible ? (_openBlock(), _createBlock(_unref(AddMovie), {
        key: 2,
        modelValue: addMovie.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => addMovie.visible = $event),
        onUpdateList: updateList,
        "detail-info": data.detailInfo
      }, null, 8, ["modelValue", "detail-info"])) : _createCommentVNode("", true), _createVNode(_unref(DialogProgress), {
        ref_key: "dialogProgressRef",
        ref: dialogProgressRef,
        modelValue: dialogProgress.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dialogProgress.visible = $event),
        percentage: importPercentage.value,
        onOnCancel: onPercentageCancel
      }, null, 8, ["modelValue", "percentage"]), _createVNode(_unref(RelevanceInfoDialog), {
        modelValue: relevanceInfoDialog.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => relevanceInfoDialog.visible = $event),
        "info-tree-data": infoTreeData.value
      }, null, 8, ["modelValue", "info-tree-data"]), _createVNode(_unref(SubtitleTranslationTable), {
        "row-data": rowData.value,
        modelValue: subtitleTranslationTable.visible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => subtitleTranslationTable.visible = $event)
      }, null, 8, ["row-data", "modelValue"]), _createVNode(_unref(CloudDiskInfo), {
        modelValue: cloudDiskInfoObj.value.visible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => cloudDiskInfoObj.value.visible = $event),
        programInfo: cloudDiskInfoObj.value.programInfo,
        data: cloudDiskInfoObj.value.data,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "programInfo", "data"]), _createVNode(BatchLinkCloudDisk, {
        modelValue: cloudDiskDialog.value.visible,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => cloudDiskDialog.value.visible = $event),
        mode: cloudDiskDialog.value.mode,
        selectedChannel: cloudDiskDialog.value.data,
        programType: cloudDiskDialog.value.programType,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "mode", "selectedChannel", "programType"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_form, {
          ref_key: "uploadRef",
          ref: uploadRef,
          model: uploadConfig.formData
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "type",
            rules: uploadConfig.rules.type
          }, {
            default: _withCtx(() => [_createVNode(_component_WidgetItem, {
              "widget-config": uploadConfig.formList[0],
              "widget-data": uploadConfig.formData
            }, null, 8, ["widget-config", "widget-data"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            prop: "selectTreeData"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElTree), {
              style: {
                "width": "100%",
                "height": "350px",
                "overflow": "auto"
              },
              ref_key: "uploadTreeRef",
              ref: uploadTreeRef,
              "node-key": "id",
              "default-expand-all": "",
              onCheck: handleImportCheck,
              data: treeData.dataList,
              props: treeData.props,
              "show-checkbox": "",
              height: 208
            }, {
              default: _withCtx(({
                node,
                data
              }) => [_createVNode(_component_MPopper, {
                disabled: tipDisabled.value,
                placement: "top",
                trigger: "hover",
                content: node.label
              }, {
                reference: _withCtx(() => [_createElementVNode("span", {
                  onMouseover: showTextTip,
                  class: "text-overflow"
                }, _toDisplayString(node.label), 33)]),
                _: 2
              }, 1032, ["disabled", "content"])]),
              _: 1
            }, 8, ["data", "props"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "file",
            rules: uploadConfig.rules.file
          }, {
            default: _withCtx(() => [dialogConfig.visible ? (_openBlock(), _createBlock(_unref(ManuallyUpload), {
              key: 0,
              style: {
                "width": "100%"
              },
              limit: 1,
              cover: "",
              fileType: ['xlsx', 'xls'],
              accept: ".xlsx,.xls",
              onHandleChange: fileChange,
              onHandelRemove: handelRemove
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                plain: ""
              }, {
                default: _withCtx(() => [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('选择文件')), 1)]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])])])), [[_directive_loading, treeData.loading]])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(GetChannelDetail, {
        modelValue: channelDetaiObj.value.visible,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => channelDetaiObj.value.visible = $event),
        data: channelDetaiObj.value.data
      }, null, 8, ["modelValue", "data"]), _createVNode(PaidSetting, {
        modelValue: paidSettingObj.visible,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => paidSettingObj.visible = $event),
        data: paidSettingObj,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "data"])], 64);
    };
  }

});